// extracted by mini-css-extract-plugin
module.exports = {"detail":"EditableDetail_detail__imeuL","label":"EditableDetail_label__274uL","value":"EditableDetail_value___b6K4"};